import { set } from 'lodash'

type Set = typeof set

export const objectSet: Set = set
